var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{attrs:{"src":require("@/assets/icons/jun_group_icon.webp"),"alt":"jun group icon"}})
}
var staticRenderFns = []

export { render, staticRenderFns }